import React from 'react'
import FormControl from '@mui/material/FormControl'
import Grid from '@mui/material/Grid'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'

const Method = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} lg={4}>
    <FormControl fullWidth>
      <InputLabel>Method</InputLabel>
      <Select
        value={moduleValues?.['Method'] ?? ''}
        onChange={(e) =>
          setModuleValues((prev) => ({
            ...prev,
            ['Method']: e.target.value,
          }))
        }
        label="Method"
      >
        <MenuItem value="Steri-Strips">Steri-Strips</MenuItem>
        <MenuItem value="Tissue Adhesive">Tissue Adhesive (Glue)</MenuItem>
        <MenuItem value="Sutures">Sutures</MenuItem>
        <MenuItem value="Staples">Staples</MenuItem>
        <MenuItem value="Hair Apposition">Hair Apposition</MenuItem>
      </Select>
    </FormControl>
  </Grid>
)

export default Method
